// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__--Xv7","footerContent":"footer_footerContent__duq4o","termosLink":"footer_termosLink__4CJu1"};